import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { FLEET_VEHICLES_TABS } from 'components/vehicles/FleetVehiclesFilters/constants';
import {
  togglePinnedFiltersState,
  selectFleetVehiclesPinnedFilters,
} from '@store';

export const useFleetVehiclesFilterConfig = ({ categoryClasses }) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectFleetVehiclesPinnedFilters);

  const filterCategories = useMemo(
    () => [
      {
        id: 'categoryClass',
        label: 'Category Class',
        icon: RadioButtonUncheckedIcon,
        options: categoryClasses,
        multiSelect: true,
      },
      {
        id: 'stage',
        label: 'Stage',
        icon: RadioButtonUncheckedIcon,
        options: Object.keys(FLEET_VEHICLES_TABS).map((tab) => ({
          value: FLEET_VEHICLES_TABS[tab].key,
          text: FLEET_VEHICLES_TABS[tab].label,
        })),
      },
      {
        id: 'plannedDownpaymentDate',
        label: 'Planned Downpayment Date',
        icon: CalendarTodayIcon,
        type: 'dateTime',
        showTime: false,
      },
      {
        id: 'licenseIssuanceDate',
        label: 'License Issuance Date',
        icon: CalendarTodayIcon,
        type: 'dateTime',
        showTime: false,
      },
      {
        id: 'plannedReceiptDate',
        label: 'Planned Receipt Date',
        icon: CalendarTodayIcon,
        type: 'dateTime',
        showTime: false,
      },
      {
        id: 'receiptDate',
        label: 'Receipt Date',
        icon: CalendarTodayIcon,
        type: 'dateTime',
        showTime: false,
      },
    ],
    [categoryClasses]
  );

  const currentFilters = useMemo(() => {
    const parseQueryValue = (value) => {
      if (!value) return [];
      if (typeof value === 'string') {
        return value.split(',').filter(Boolean);
      }
      return Array.isArray(value) ? value : [];
    };

    return {
      categoryClass: parseQueryValue(router.query.categoryClass),
      plannedDownpaymentDate: router.query.plannedDownpaymentDate || null,
      licenseIssuanceDate: router.query.licenseIssuanceDate || null,
      plannedReceiptDate: router.query.plannedReceiptDate || null,
      receiptDate: router.query.receiptDate || null,
      stage: parseQueryValue(router.query.stage),
    };
  }, [router.query]);

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({ board: 'fleetVehicles', pinnedFilter })
    );
  };

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
  };
};
